import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { HaSurveyserviceService } from '../../services/HaSurvey.service';
import { HaSurveypatientModal } from '../../models/HaSurveyPatient.model';
import { HaPatientlistService } from '../../services/HaPatientList.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ShareSurveyToPatientModal } from '../../models/ShareSurveyToPatient.model';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-ha-surveymain',
  templateUrl: './ha-surveymain.component.html',
  styleUrls: ['./ha-surveymain.component.css']
})

export class HaSurveymainComponent implements OnInit {
  element: HTMLElement;
  surveyGroupId: string;
  surveyData: any[];
  currentSurvey: string;
  patShare: HaSurveypatientModal[];
  addedList: any[] = [];
  selectedPatientShow: boolean = false;
  searchTerm: string = '';
  showEmpty: boolean;
  loaderShare: boolean = false;
  loaderDelete: boolean = false;
  listView: boolean = false;
  doctorList: any[];
  docValue: string = "";
  searchPatientData: string = "";
  showOverlaySurveyMain: boolean;
  page: number = 1;
  mainViewError = new ErrorModel();
  patientLoadError = new ErrorModel();
  constructor(private router: Router, private _service: HaSurveyserviceService, private __service: HaPatientlistService) { }
  ngOnInit() {
    this.docValue = '';
    this.getAllHaSurveys();
  }

  getAllHaSurveys() {
    this.showOverlaySurveyMain = true;
    this.mainViewError.display = false;
    this._service.getAllHaSurveys().subscribe(
    (data: any[]) => {
      this.surveyData = data;
      if (this.surveyData == undefined || this.surveyData == null) {
        this.showEmpty = true;
      } else if (this.surveyData.length == 0) {
        this.showEmpty = true;
      } else {
        this.showEmpty = false;
      }
      this.getDoctors();
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;

    }).add(() => {
      this.showOverlaySurveyMain = false;
    });
  }

  getDoctors() {
    this.__service.getDoctorsList().subscribe(
    (data: any[]) => {
      this.doctorList = data;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Can\'t load Doctors! ', AlertType.Error);
      this.getAllHaSurveys();
    });
  }

  routeCreateSurvey() {
    this.router.navigate(['Hospital/HAAdmin/CreateSurvey'], {
      queryParams: {}
    });
  }

  routeToHaSurveyManagementDisplay(data) {
    this.router.navigate(['Hospital/HAAdmin/HaSurveymanagementdisplay'], {
      queryParams: {
        'Survey_Id': data.id,
        'Name': data.name,
        'Reason': data.reason,
        'totalQuestions': data.questions,
        'sharedPatients': data.patients,
        'SurveyCompletedCounts': data.counts,
        'createdOn': data.created
      },
      skipLocationChange: true
    });
  }

  closeNav() {
    this.docValue = '';
    this.surveyGroupId = '';
    this.searchPatientData = '';
    this.addedList = [];
    this.resetBorder();
    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = '-105%';
    this.element.style.opacity = '0';
  }

  routeCreateSurveyCreate() {
    this.router.navigate(['Hospital/HAAdmin/HaSurveymanagementCreate'], {
      queryParams: {}
    });
  }

  onEvent(data) {
    this.loaderShare = true;
    data.evt.stopPropagation();
    this.openNav(data.id);
  }

  openNav(id) {
    this.surveyGroupId = '';
    this.addedList = [];
    this.patShare = [];
    this.resetBorder();
    let indexOne = this.surveyData.findIndex(survey => survey.id == id);
    this.surveyData[indexOne].border = '2px solid #0969c9';
    this.surveyData[indexOne].borderBottom = '2px solid #0969c9';
    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = '0px';
    this.element.style.opacity = '1';
    this.surveyGroupId = id;
    this.getPatientsToShareSurveyWith(1, '', '');
  }

  resetBorder() {
    for (let cases of this.surveyData) {
      cases.border = '';
      cases.borderBottom = '';
    }
  }

  //api/Ha/Survey/getPatientsToShareSurveyWith
  getPatientsToShareSurveyWith(page, text, eaId) {
    this.patientLoadError.display = false;
    this.loaderShare = true;
    this.patShare = [];
    this._service.getPatientsToShareSurveyWith(page, text.trim(), eaId).subscribe(
    (data: HaSurveypatientModal[]) => {
      this.patShare = data;
      this.filterData();

      this.page = 1;
    },
    (error) => {
      this.patientLoadError.error = error;
      this.patientLoadError.display = true;
    }).add(() => {
      this.loaderShare = false;
    });
  }

  onScroll2(patientVal, docVal) {
    this.loaderShare = true;
    this.page = this.page + 1;
    this._service.getPatientsToShareSurveyWith(this.page, patientVal.trim(), docVal).subscribe(
    (data: HaSurveypatientModal[]) => {
      if (data != undefined) {
        data.forEach(item => {
          this.patShare.push(item);
          this.filterData();

        });
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load!', AlertType.Error);
      this.page = this.page - 1;
    }).add(() => {
      this.loaderShare = false;
    });
  }

  filterData() {
    if (this.patShare !== undefined && this.patShare !== null && this.patShare.length > 0) {
      if (this.addedList !== undefined && this.addedList !== null) {
        if (this.addedList.length > 0) {
          this.addedList.forEach(element => {
            const indexFilter = this.patShare.filter(patient => patient.id == element.id)[0];
            if (indexFilter !== undefined) {
              const indexOfPatient = this.patShare.indexOf(indexFilter);
              this.patShare[indexOfPatient].isChecked = true;
            }
          });
        }
      }
    }
  }

  onEventDelete(data) {
    data.evt.stopPropagation();
    this.deleteSurvey(data.id);
  }

  deleteSurvey(surveyId) {
    const resp = confirm('Are you sure you want to delete this survey');
    if (resp == true) {
      this.loaderDelete = true;
      this._service.deleteSurveyPaper(surveyId).subscribe(
      (data) => {
        this.alertCloseSurvey();
        AlertMessages.Show('Deleted', 'Survey Deleted!!!', AlertType.Success);
        this.closeNav();
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not Delete!', AlertType.Error);
        this.loaderDelete = false;
      });
    }
  }

  alertCloseSurvey() {
    setTimeout(() => {
      this.loaderDelete = false;
      this.getAllHaSurveys();
    }, 1000);
  }

  storePatients(event, id, pat) {
    if (event.target.checked == true) {
      let index = this.patShare.filter(i => i.id == id)[0];
      if (index !== undefined) {
        let indexOne = this.patShare.indexOf(index);
        this.patShare[indexOne].isChecked = true;
      }
      let indexTwo = this.addedList.filter(i => i.id == id)[0];
      if (indexTwo !== undefined) {
        let indexThree = this.addedList.indexOf(indexTwo);
        this.addedList.splice(indexThree, 1);
      }
      this.addedList.push({
        "id": id,
        "fullName": pat.fullName,
        "patientId": pat.patientId,
        "emailId": pat.emailId,
        "gender": pat.gender,
        "profilePhoto": pat.photoUrl,
        "isChecked": false
      });
    } else {
      let index = this.patShare.filter(i => i.id == id)[0];
      if (index !== undefined) {
        let indexFive = this.patShare.indexOf(index);
        this.patShare[indexFive].isChecked = false;
      }
      let indexTwo = this.addedList.filter(i => i.id == id)[0];
      if (indexTwo !== undefined) {
        let indexThree = this.addedList.indexOf(indexTwo);
        this.addedList.splice(indexThree, 1);
      }
    }
  }

  clearlist() {
    this.addedList = [];
  }

  onEventSurveyShare(pId, event) {
    event.stopPropagation();
    this.shareToPat(pId, event);
  }

  shareToPat(element, event) {
    this.currentSurvey = element;
    event.stopPropagation();
    $("#shareModal2222").modal('show');
  }

  sharePatient(event) {
    if (this.surveyGroupId == "" || this.surveyGroupId == undefined || this.surveyGroupId == null || this.addedList == undefined || this.addedList == null || this.addedList.length == 0) {
      AlertMessages.Show('WARNING', 'Please Select Patient to Share', AlertType.Warning);
    } else {
      this.loaderShare = true;
      let shareModal: ShareSurveyToPatientModal = new ShareSurveyToPatientModal(this.addedList, this.surveyGroupId);
      this._service.shareSurveyWithPatient(shareModal).subscribe(
      (data) => {
        AlertMessages.Show('Success', 'Shared with patient(s)', AlertType.Success);
        this.loaderShare = false;
        window.location.reload();
        this.closeNav1();
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not share!', AlertType.Error);

      }).add(() => {
        this.loaderShare = false;
      });
    }
  }

  closeNav1() {
    this.surveyGroupId = '';
    this.addedList = [];
    this.getAllHaSurveys();
    for (let cases of this.surveyData) {
      cases.border = '';
    }
    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = '-62%';
    this.element.style.opacity = '0';
  }

  showInserted() {
    this.selectedPatientShow = true;
  }

  hideInserted() {
    this.selectedPatientShow = false;
  }
}
